import './http.js'
import { removeCookie } from 'tiny-cookie'
import {
  getIndex,
  by,
  subArg,
  generateUrl,
  getCookie,
  getIdArray,
  isAdBlock,
} from '@common/js/common'
import store from '../vuex/store'
import router from '../router'

export default {
  install(Vue) {
    Vue.prototype.getIndex = getIndex
    Vue.prototype.by = by
    Vue.prototype.generateUrl = generateUrl
    Vue.prototype.getIdArray = getIdArray
    Vue.prototype.subArg = subArg
    Vue.prototype.isAdBlock = isAdBlock
    Vue.prototype.formatData = function(data, format) {
      if (!data) {
        return '-'
      }
      if (!format) {
        return data
      }
      var result = data
      if (~format.indexOf(',')) {
        var temp = data.toString()
        var int_ = data
        var float_ = ''
        if (~temp.indexOf('.')) {
          // 浮点数分割
          var temp_array = temp.split('.')
          int_ = temp_array[0]
          float_ = temp_array[1]
        }
        result =
          int_.toString().replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,') + (float_ ? '.' + float_ : '')
      }
      if (~format.indexOf('$')) {
        result = '$' + result
      }
      return result
    }

    Vue.prototype.changePageItem = function(page, data) {
      page.tot = data.tot
      page.from = (page.cur - 1) * page.per + 1
      page.to = parseInt(page.from) + parseInt(page.per) - 1
      if (page.to > page.tot) {
        page.to = page.tot
      }
    }

    Vue.prototype.Logout = function() {
      removeCookie('login')
      this.$http.get('/accounts/logout/').then(() => {
        if (this.$store) {
          this.$store.dispatch('reset')
        }
        router.push({ name: 'aff-login' })
      })
    }

    Vue.prototype.aderLogout = function() {
      let next = false
      if (!getCookie('login')) {
        next = true
      }

      var path = location.pathname
      this.$http.get('/accounts/logout/').then(() => {
        removeCookie('login')
        if (this.$store) {
          this.$store.dispatch('reset')
        }
        if (path && next) {
          router.push({ name: 'login', query: { next: path } })
        } else {
          router.push({ name: 'login' })
        }
      })
    }

    Vue.prototype.Login = function() {
      if (this.isAderURL()) {
        // 广告主登录
        router.push({ name: 'login' })
      } else {
        // 渠道登录
        router.push({ name: 'aff-login' })
      }
    }

    Vue.prototype.registData = {
      account_type: [{ name: 'Company', id: 1 }, { name: 'Individual/Team', id: 0 }],
      customer_type: [
        { name: 'Network', id: 1 },
        { name: 'Affiliate', id: 0 },
        { name: 'Direct Traffic', id: 2 },
        { name: 'Web Site', id: 3 },
      ],
      company_size: [
        { id: 11, name: '1-50' },
        { id: 12, name: '51-100' },
        { id: 13, name: '101-300' },
        { id: 14, name: 'more than 300' },
      ],
      team_size: [
        { id: 1, name: '1 Independent - not full time' },
        { id: 2, name: '1 Independent - full time' },
        { id: 3, name: '2-5' },
        { id: 4, name: '6-10' },
        { id: 5, name: 'more than 10' },
      ],
      traffic_source: [
        { id: 3, name: 'Facebook' },
        { id: 4, name: 'In-App' },
        { id: 5, name: 'Direct Pub' },
        { id: 7, name: 'Display' },
        { id: 8, name: 'Other' },
        { id: 9, name: 'Adwords' },
        { id: 10, name: 'Pop' },
        { id: 11, name: 'Web' },
        { id: 12, name: 'Native' },
        { id: 13, name: 'Email Traffic' },
        { id: 14, name: 'Mediabuy' },
      ],
      cpi_type: [
        { id: 37, name: 'Game' },
        { id: 31, name: 'Tools' },
        { id: 35, name: 'E-commerce' },
        { id: 0, name: 'Other' },
      ],
      cpa_type: [
        { id: -110, name: '1/2 Click' },
        { id: 133, name: 'CPS' },
        { id: 113, name: 'CPL/CPR' },
        { id: -114, name: 'SOI/DOI' },
        { id: 115, name: 'pin submit' },
        { id: 117, name: 'smartlink' },
        { id: 125, name: 'Others' },
      ],
      daily_budget: [
        { id: 1, name: '<$100' },
        { id: 2, name: '$100-$300' },
        { id: 3, name: '$300-$500' },
        { id: 4, name: '$500-$1000' },
        { id: 5, name: '>$1000' },
      ],
      approach: [
        { id: 1, name: 'Exhibition' },
        { id: 2, name: 'Forum' },
        { id: 3, name: 'Search Engines' },
        { id: 4, name: 'Facebook' },
        { id: 5, name: 'Linkedin' },
        { id: 6, name: 'Twitter' },
        { id: 7, name: 'Other' },
      ],
    }

    // 通知窗口
    Vue.prototype.notifyOpen = function(title, msg, type, duration) {
      msg = msg || (type === 'success' || !type ? 'Success' : 'Error')
      this.$notify({
        title: title || 'Success',
        message: msg,
        type: type || 'success',
        duration: duration !== undefined ? duration : type === 'success' || !type ? 5000 : 10000,
      })
    }

    // 确认窗口
    Vue.prototype.confirmOpen = function(
      msg = 'Are you sure?',
      success = () => {},
      error = () => {}
    ) {
      this.$confirm('', msg, {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true,
      })
        .then(success)
        .catch(error)
    }

    Vue.prototype.isFormValid = function(form) {
      let form_valid = false
      this.$refs[form].validate(valid => {
        if (valid) {
          form_valid = true
        }
      })
      return form_valid
    }

    Vue.prototype.onCopy = () => {
      Vue.prototype.notifyOpen()
    }

    Vue.prototype.setTitle = function(title) {
      document.title = title ? `${title} | Youmi` : 'Youmi Offers'
    }

    Vue.prototype.updateInfo = function(path, direct) {
      if (!direct && this.settings.user.info) {
        store.commit('TIP_SHOW', true)
        return
      }
      this.routerChange('personal-info')
      // location.href = `/accounts/center/update-info?goto=${location.origin}${path}`
    }

    Vue.prototype.isAderURL = function() {
      return /adv/.test(location.host)
    }

    Vue.prototype.isAder = function() {
      return this.settings.usertype === 2
    }

    Vue.prototype.isAff = function() {
      return this.settings.usertype === 3
    }

    Vue.prototype.isSDKAff = function() {
      return this.settings.usertype === 3 && this.settings.user.is_sdk === true
    }
  },
}
